import type { TSuggestedKeywords } from '@/types/suggestedKeywords'

// User Profile
export const DEFAULT_USER_PROFILE_KEYWORDS = ['inovácie', 'marketing', 'strategy', 'automotive', 'enviro']

// Mentor Profile
export const DEFAULT_MENTOR_PROFILE_KEYWORDS = [
    'Sebarozvoj',
    'Výber univerzity',
    'Rozbeh projektu',
    'Kariéra',
    'Start-up'
] //profileForm

// Volunteer Profile
export const DEFAULT_VOLUNTEER_PROFILE_KEYWORDS = [
    'Marketing',
    'Právo',
    'Expertné dobrovoľníctvo',
    'Zdravie',
    'Sociálna oblasť',
    'Ekológia',
    'Deti a mládež',
    'Podujatia'
]

// Org Profile
export const DEFAULT_ORG_PROFILE_KEYWORDS = ['inovácie', 'digitalizácia', 'vzdelávanie', 'automobilový priemysel']

// Job
export const DEFAULT_JOB_KEYWORDS = ['Marketing', 'HR', 'Projektový manažment', 'Financie', 'Inovácie', 'Analýza']

// Project
export const DEFAULT_PROJECT_KEYWORDS = [
    'expertné dobrovoľníctvo',
    'zdravie',
    'sociálna oblasť',
    'ekológia',
    'deti a mládež',
    'kultúra',
    'IT',
    'právo',
    'marketing',
    'podujatia'
]

// Skill
export const DEFAULT_SKILL_KEYWORDS = ['Vzdelávanie', 'IT', 'Leadership', 'Inovácie', 'Dezinformácie']

// Eduvalue
export const EDUVALUE_KEYWORDS = [
    'eduvalue',
    'kritické myslenie',
    'finančná gramotnosť',
    'digitálne zručnosti',
    'umenie',
    'zručnosti 21. storočia',
    'sebarozvoj',
    'inklúzia',
    'STEAM zručnosti',
    'charakterové vzdelávanie',
    'rozvoj podnikavosti',
    'projektové učenie',
    'inovácie v didaktike',
    'zážitkové vzdelávanie',
    'rozvoj komunít',
    'environmentálna výchova',
    'inovatívna inštitúcia/škola'
]

export const SUGGESTED_KEYWORDS: TSuggestedKeywords = {
    profileForm: {
        default: {
            suggested: DEFAULT_USER_PROFILE_KEYWORDS,
            featured: []
        },
        eduvalue: {
            suggested: EDUVALUE_KEYWORDS,
            featured: EDUVALUE_KEYWORDS.slice(0, 1)
        }
    },
    mentorProfileForm: {
        default: {
            suggested: DEFAULT_MENTOR_PROFILE_KEYWORDS,
            featured: []
        },
        eduvalue: {
            suggested: EDUVALUE_KEYWORDS,
            featured: EDUVALUE_KEYWORDS.slice(0, 1)
        }
    },
    menteeProfileForm: {
        default: {
            suggested: DEFAULT_MENTOR_PROFILE_KEYWORDS,
            featured: []
        },
        eduvalue: {
            suggested: EDUVALUE_KEYWORDS,
            featured: EDUVALUE_KEYWORDS.slice(0, 1)
        }
    },
    volunteerProfileForm: {
        default: {
            suggested: DEFAULT_VOLUNTEER_PROFILE_KEYWORDS,
            featured: []
        },
        eduvalue: {
            suggested: EDUVALUE_KEYWORDS,
            featured: EDUVALUE_KEYWORDS.slice(0, 1)
        }
    },
    orgForm: {
        default: {
            suggested: DEFAULT_ORG_PROFILE_KEYWORDS,
            featured: []
        },
        eduvalue: {
            suggested: EDUVALUE_KEYWORDS,
            featured: EDUVALUE_KEYWORDS.slice(0, 1)
        }
    },
    jobForm: {
        default: {
            suggested: DEFAULT_JOB_KEYWORDS,
            featured: []
        },
        eduvalue: {
            suggested: EDUVALUE_KEYWORDS,
            featured: EDUVALUE_KEYWORDS.slice(0, 1)
        }
    },
    projectForm: {
        default: {
            suggested: DEFAULT_PROJECT_KEYWORDS,
            featured: []
        },
        eduvalue: {
            suggested: EDUVALUE_KEYWORDS,
            featured: EDUVALUE_KEYWORDS.slice(0, 1)
        }
    },
    skillForm: {
        default: {
            suggested: DEFAULT_SKILL_KEYWORDS,
            featured: []
        },
        eduvalue: {
            suggested: EDUVALUE_KEYWORDS,
            featured: EDUVALUE_KEYWORDS.slice(0, 1)
        }
    },
    eduvalue: {
        default: {
            suggested: EDUVALUE_KEYWORDS,
            featured: []
        },
        eduvalue: {
            suggested: EDUVALUE_KEYWORDS,
            featured: EDUVALUE_KEYWORDS.slice(0, 1)
        }
    }
}

export type TSuggestedKeywordsSource = keyof TSuggestedKeywords | 'default'
